module.exports = __webpack_public_path__ + "img/img_sub_ser_consulting02.a4869612.svg";